import { useWorkbookId } from "@/hooks/use-workbook";
import queries from "@/queries";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

export const useCategory = () => {
  const { data: workbookId } = useWorkbookId();
  const { categoryId } = useParams<{ categoryId: string }>();

  const { data: categories } = useQuery({
    ...queries.workbook(workbookId!)._ctx.categories(),
    enabled: !!workbookId,
    select: (data) => data.categories,
  });

  const category = useMemo(
    () => categories?.find((c) => c.id === categoryId) ?? null,
    [categories, categoryId],
  );

  return { category };
};
